module.exports = __webpack_public_path__ + "img/error-payment-general.4c5a1ab.svg";